module.exports = __webpack_public_path__ + "static/media/close--light.e3317369.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/close--light.svg
// module id = 184
// module chunks = 0